import React from 'react';
import { ReportDeviation } from './ReportDeviation';
import { fetchPostDeviationAsync } from 'fetch/deviationFetch';
import { Order } from '../../types/orderTypes';

export function ReportDeviationPost({ order }: { order: Order }): JSX.Element {
  const sendMessage = async (_, message, status) => {
    await fetchPostDeviationAsync(order.id, message, status);
    setTimeout(() => window.location.reload(), 1600);
  };

  return (
    <>
      <ReportDeviation order={order} sendMessage={sendMessage} />
    </>
  );
}
